<template>
  <div class="site-event-main" :style="hasNoContentAuth ? { height: '100%' } : {}">
    <div v-if="hasNoContentAuth" class="site-event-main-empty">
      <NoAuth />
    </div>

    <!-- 搜索排序 -->
    <div class="site-event-action" v-if="tabLists && tabLists.length > 0">
      <div class="site-event-action-content">
        <!-- tab -->
        <ul class="site-event-tab">
          <li
            v-for="tab in tabLists"
            :key="tab.key"
            :class="activeTabKey === tab.key ? 'active' : ''"
            @click="handleTabs(tab.key)"
          >
            {{ tab.name }}
          </li>
        </ul>

        <!-- 站点编辑事件搜索 -->
        <div class="site-event-action-row1" v-if="activeTabKey === '1'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_param_event_placeholder')"
                v-model="stationEditSearch.keyword"
                @pressEnter="getData(true)"
                @change="
                  () => {
                    if (!stationEditSearch.keyword) {
                      this.getData(true);
                    }
                  }
                "
                class="site-event-search-keyword"
                allowClear
              />
            </li>
            <li>
              <a-range-picker @change="stationEditDateChange" v-model="stationEditSearchDate" />
            </li>
            <li>
              <a-button type="primary" @click="getData(true)">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="resetStationEditSearch">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
        </div>

        <!-- 设备编辑事件搜索  -->
        <div class="site-event-action-row1" v-if="activeTabKey === '2'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_param_event_placeholder')"
                v-model="deviceEditSearch.keyword"
                @pressEnter="getData(true)"
                @change="
                  () => {
                    if (!deviceEditSearch.keyword) {
                      getData(true);
                    }
                  }
                "
                allowClear
                class="site-event-search-keyword"
              />
            </li>
            <li>
              <a-range-picker @change="deviceEditDateChange" v-model="deviceEditSearchDate" />
            </li>
            <li>
              <a-button type="primary" @click="getData(true)">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="resetDeviceEditSearch">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
        </div>

        <!-- 设备控制事件搜索  -->
        <div class="site-event-action-row1" v-if="activeTabKey === '3'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_param_event_placeholder')"
                v-model="deviceControlSearch.keyword"
                @pressEnter="getData(true)"
                @change="
                  () => {
                    if (!deviceControlSearch.keyword) {
                      getData(true);
                    }
                  }
                "
                class="site-event-search-keyword"
                allowClear
              />
            </li>
            <li>
              <a-range-picker @change="deviceControlDateChange" v-model="deviceControlSearchDate" />
            </li>
            <li>
              <a-button type="primary" @click="getData(true)">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="resetDeviceControlSearch">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
          <div class="site-event-btn">
            <a-button type="link" @click="handleExpand()">
              <span v-if="!searchExpand">{{ $t('com_btn_expand') }}</span>
              <span v-else>{{ $t('com_btn_collapse') }}</span>
              <a-icon type="up" v-if="searchExpand" />
              <a-icon type="down" v-else />
            </a-button>
          </div>
        </div>

        <!-- 设备配置事件搜索  -->
        <div class="site-event-action-row1" v-if="activeTabKey === '4'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_param_event_placeholder')"
                v-model="deviceConfigSearch.keyword"
                @pressEnter="getData(true)"
                @change="
                  () => {
                    if (!deviceConfigSearch.keyword) {
                      getData(true);
                    }
                  }
                "
                class="site-event-search-keyword"
                allowClear
              />
            </li>
            <li>
              <a-range-picker @change="deviceConfigDateChange" v-model="deviceConfigSearchDate" />
            </li>
            <li>
              <a-button type="primary" @click="getData(true)">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="resetDeviceConfigSearch">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
        </div>

        <!-- 展开的搜索 -->
        <div class="site-event-action-row2" v-if="searchExpand && activeTabKey === '3'">
          <span>{{ $t('device_control_type') }}</span>
          <a-checkbox-group v-model="deviceControlSearch.types" @change="getData(true)">
            <a-checkbox
              :value="item.protoEventType"
              v-for="(item, index) in deviceControlType"
              :key="item.id + '_' + index"
            >
              {{ item.cmdName }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="site-event-content g-table" v-if="tabLists && tabLists.length > 0">
      <!-- 站点编辑事件列表 -->
      <div v-if="activeTabKey === '1'">
        <a-table
          :columns="stationEditColumns"
          :data-source="stationEditData"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleStationEditTableChange"
          :loading="tableLoading"
        >
          <!-- 数据内容 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              {{ text }}
            </div>
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            {{ text | location }}
          </template>

          <!-- 类型 -->
          <template slot="updateType" slot-scope="text">
            <span v-for="item in $t('com_operationTypes')" :key="item.value">
              <span v-if="text === item.value">
                {{ item.name }}
              </span>
            </span>
          </template>

          <!-- 时间 -->
          <template slot="executeTime" slot-scope="text">
            {{ text | formatDate }}
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="stationEditPagination.current"
            :total="stationEditPagination.total"
            :pageSize.sync="stationEditPagination.pageSize"
            :callback="stationEditPageChange"
            @change="stationEditPageChange"
          />
        </div>
      </div>

      <!-- 2 -->
      <div v-else-if="activeTabKey === '2'">
        <a-table
          :columns="deviceEditColumns"
          :data-source="deviceEditData"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleDeviceEditTableChange"
          :loading="tableLoading"
        >
          <!-- 名称 -->
          <template slot="devName" slot-scope="text">
            <div class="g-table-text">{{ text }}</div>
          </template>

          <!-- 数据内容 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              {{ text }}
            </div>
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            <div class="g-table-text">
              {{ text | location }}
            </div>
          </template>

          <!-- 类型 -->
          <template slot="updateType" slot-scope="text">
            <span v-for="item in $t('com_operationTypes')" :key="item.value">
              <span v-if="text === item.value">
                {{ item.name }}
              </span>
            </span>
          </template>

          <!-- 时间 -->
          <template slot="executeTime" slot-scope="text">
            {{ text | formatDate }}
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="deviceEditPagination.current"
            :total="deviceEditPagination.total"
            :pageSize.sync="deviceEditPagination.pageSize"
            :callback="deviceEditPageChange"
            @change="deviceEditPageChange"
          />
        </div>
      </div>

      <!-- 3 -->
      <div v-else-if="activeTabKey === '3'">
        <a-table
          :columns="deviceControlColumns"
          :data-source="deviceControlData"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleDeviceControlTableChange"
          :loading="tableLoading"
        >
          <!-- 名称 -->
          <template slot="devName" slot-scope="text">
            <div class="g-table-text">{{ text }}</div>
          </template>

          <!-- 类型 -->
          <template slot="operationType" slot-scope="text">
            <span>{{ $t('device_control_log_type')[text] }}</span>
          </template>

          <!-- 数据内容 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              {{ text }}
            </div>
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            {{ text | location }}
          </template>

          <!-- 时间 -->
          <template slot="executeStartTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 时间 -->
          <template slot="executeEndTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
            <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
            <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
            <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="deviceControlPagination.current"
            :total="deviceControlPagination.total"
            :pageSize.sync="deviceControlPagination.pageSize"
            :callback="deviceControlPageChange"
            @change="deviceControlPageChange"
          />
        </div>
      </div>

      <!-- 4 -->
      <div v-else-if="activeTabKey === '4'">
        <a-table
          :columns="deviceConfigColumns"
          :data-source="deviceConfigData"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleDeviceConfigTableChange"
          :loading="tableLoading"
        >
          <!-- 数据内容 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              {{ text }}
            </div>
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            <div class="g-table-text">
              {{ text | location }}
            </div>
          </template>

          <!-- executeStartTime -->
          <template slot="executeStartTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- executeEndTime -->
          <template slot="executeEndTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
            <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
            <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
            <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="deviceConfigPagination.current"
            :total="deviceConfigPagination.total"
            :pageSize.sync="deviceConfigPagination.pageSize"
            :callback="deviceConfigPageChange"
            @change="deviceConfigPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StationEditMixins from '../mixins/stationEdit';
import DeviceEditMixins from '../mixins/deviceEdit';
import DeviceControlMixins from '../mixins/deviceControl';
import DeviceConfigMixins from '../mixins/deviceConfig';
import siteAuth from '@/views/site/mixins/siteAuth';

export default {
  mixins: [StationEditMixins, DeviceEditMixins, DeviceControlMixins, DeviceConfigMixins, siteAuth],
  props: {
    // 站点信息
    siteData: {
      type: Object,
      default: () => ({}),
    },
    // 站点Id
    stationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 当前tab
      activeTabKey: '1',

      tabLists: [],

      // 展开
      searchExpand: true,

      deviceList: [],

      // 列表
      columns: [],
    };
  },

  computed: {
    hasNoContentAuth() {
      return !(
        this.AUTH_SITE_EVENT_SITE_OPERATION ||
        this.AUTH_SITE_EVENT_DEVICE_OPERATION ||
        this.AUTH_SITE_EVENT_DEVICE_CONTROL ||
        this.AUTH_SITE_EVENT_DEVICE_CONFIG
      );
    },
  },

  created() {
    // 权限 - 站点 - 详情 - 事件 - 站点编辑事件
    if (this.AUTH_SITE_EVENT_SITE_OPERATION) {
      this.tabLists.push({
        key: '1',
        name: this.$t('site_tabs_edit_event'),
      });
    }

    // 权限 - 站点 - 详情 - 事件 - 设备控制事件
    if (this.AUTH_SITE_EVENT_DEVICE_OPERATION) {
      this.tabLists.push({
        key: '2',
        name: this.$t('site_tabs_device_edit_event'),
      });
    }

    // 权限 - 站点 - 详情 - 事件 - 设备操作事件
    if (this.AUTH_SITE_EVENT_DEVICE_CONTROL) {
      this.tabLists.push({
        key: '3',
        name: this.$t('site_tabs_device_control_event'),
      });
    }

    // 权限 - 站点 - 详情 - 事件 - 设备配置事件
    if (this.AUTH_SITE_EVENT_DEVICE_CONFIG) {
      this.tabLists.push({
        key: '4',
        name: this.$t('site_tabs_device_config_event'),
      });
    }

    if (this.tabLists.length > 0) {
      this.activeTabKey = this.tabLists[0].key;
    }

    this.getData();
  },
  methods: {
    handleTabs(key) {
      this.activeTabKey = key;
      this.getData();
    },

    // 获取数据
    getData(search) {
      if (this.activeTabKey === '1') {
        if (search) {
          this.stationEditPagination.current = 1;
        }
        this.getStationEditData();
      } else if (this.activeTabKey === '2') {
        if (search) {
          this.deviceEditPagination.current = 1;
        }
        this.getDeviceEditData();
      } else if (this.activeTabKey === '3') {
        if (search) {
          this.deviceControlPagination.current = 1;
        }
        this.getDeviceControlData();
      } else if (this.activeTabKey === '4') {
        if (search) {
          this.deviceConfigPagination.current = 1;
        }
        this.getDeviceConfigData();
      }
    },

    // 切换列表类型
    listTypeHandle(value) {
      this.listType = value;
    },

    // 获取设备列表
    getDeviceList() {},

    // 展开
    handleExpand() {
      this.searchExpand = !this.searchExpand;
    },
  },
};
</script>
<style lang="less" scoped>
.site-event-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  .site-event-main-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
  }

  // 搜索
  .site-event-action {
    background: @g-layout-background;
    .site-event-action-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      margin-bottom: 16px;

      .site-event-tab {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        gap: 24px;
        margin-bottom: 16px;

        li {
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          display: flex;

          &.active {
            color: @primary-color;
            font-weight: 600;
            position: relative;

            &::after {
              content: '';
              display: block;
              width: 100%;
              height: 2px;
              background: @primary-color;
              position: absolute;
              bottom: -4px;
              left: 0;
            }
          }
        }
      }

      .site-event-action-row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        // 搜索排序
        ul.site-event-search {
          display: flex;
          margin: 0;
          padding: 0;
          list-style: none;
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          li {
            display: flex;
            align-items: center;
            gap: 12px;
            &:last-child {
              width: auto;
            }

            .site-event-search-keyword {
              min-width: 430px;
            }
          }
        }

        // 排序
        .site-event-btn {
          display: flex;
          align-items: center;

          button {
            margin-left: 12px;
          }
        }
      }

      .site-event-action-row2 {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 24px 0 0 0;
        span {
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          margin-right: 16px;
          white-space: nowrap;
        }

        .ant-checkbox-group {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          flex-wrap: wrap;
          .ant-checkbox-wrapper {
            margin: 0;
          }

          .ant-checkbox {
            color: rgba(0, 0, 0, 0.88);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }

  // 内容
  .site-event-content {
    background: #fff;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    border-radius: 12px;
    flex: 1;
    padding: 24px;

    // 卡片模式
    .site-event-content-card {
      display: flex;
      grid-gap: 16px;
      padding-top: 16px;
      width: 100%;
      flex-wrap: wrap;

      li {
        width: calc(20% - 16px);
        height: 337px;
        border-radius: 6px;
        border: 1px solid #eee;

        .card-title {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
          padding: 24px 24px 0 24px;

          a {
            color: rgba(0, 0, 0, 0.88);
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: block;
            width: 100%;

            &:hover {
              color: @primary-color;
            }
          }
        }

        .card-content {
          padding: 0 24px 16px 24px;
          .card-content-time {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin: 0;

            dd {
              color: rgba(0, 0, 0, 0.45);
              font-size: 14px;
              height: 80px;
              width: 50%;
              border-radius: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              strong {
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
              }
              span {
                color: #18181a;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }

              &:first-child {
                background: #f6ffed;
                strong {
                  color: #52c41a;
                }
              }

              &:last-child {
                background: #fffbe6;
                strong {
                  color: #faad14;
                }
              }
            }
          }
          p {
            padding: 0;
            margin: 0 0 8px 0;
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            label {
              white-space: nowrap;
            }
            span {
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }

        .card-action {
          padding: 8px 0;
          border-top: #eee solid 1px;
          dl {
            display: flex;
            justify-content: space-between;

            dd {
              cursor: pointer;
              font-size: 16px;
              transition: all 0.3s;
              border-right: solid 1px rgba(0, 0, 0, 0.06);
              flex: 1;
              height: 38px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:last-child {
                border-right: none;
              }

              a {
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: center;
                color: #000;
                cursor: pointer;
                height: 100%;

                svg {
                  width: 24px;
                  height: 24px;
                  opacity: 0.45;
                }

                &:hover {
                  color: @primary-color;
                  svg.icon {
                    color: @primary-color;
                  }
                }
              }
            }
          }
        }

        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }

    // 列表模式
    .site-event-content-list {
      padding-top: 16px;

      .site-event-action {
        display: flex;
        background: none;
        padding: 0;
        margin: 0;
        height: auto;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
